import { RelatedIncidentsList } from "./RelatedIncidentsList";

export default RelatedIncidentsList;
